// @flow
export const UTM = '@@MAPFILTER/COORD_FORMATS/UTM'
export const DEC_DEG = '@@MAPFILTER/COORD_FORMATS/DEC_DEG'
export const DEG_MIN_SEC = '@@MAPFILTER/COORD_FORMATS/DEG_MIN_SEC'
